import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

/**
 * Google Analytics 4 integration.
 * - Reads ga_measurement_id from /api/settings.
 * - Only loads if the cookie banner has been accepted.
 * - Tracks page views on every route change.
 */
export default function GoogleAnalytics() {
  const [gaId, setGaId] = useState("");
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();

  // Fetch settings once
  useEffect(() => {
    api
      .get("/settings")
      .then((r) => {
        const id = (r.data?.ga_measurement_id || "").trim();
        if (/^G-[A-Z0-9]{6,}$/i.test(id)) setGaId(id);
      })
      .catch(() => {});
  }, []);

  // Inject gtag script when we have an id and cookies accepted
  useEffect(() => {
    if (!gaId || loaded) return;

    const tryLoad = () => {
      if (loaded) return;
      if (localStorage.getItem("bs_cookies_ok") !== "1") return;

      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(s);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", gaId, { send_page_view: false });
      setLoaded(true);
    };

    tryLoad();
    window.addEventListener("bs-cookies-accepted", tryLoad);
    return () => window.removeEventListener("bs-cookies-accepted", tryLoad);
  }, [gaId, loaded]);

  // Track page views on route change
  useEffect(() => {
    if (!loaded || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location, loaded]);

  return null;
}
